import { render } from "./Alpha.vue?vue&type=template&id=ecf7d10e&scoped=true&ts=true"
import script from "./Alpha.vue?vue&type=script&lang=ts"
export * from "./Alpha.vue?vue&type=script&lang=ts"

import "./Alpha.vue?vue&type=style&index=0&id=ecf7d10e&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecf7d10e"]])

export default __exports__